import { motion } from 'framer-motion';
import { ArrowUpRight, Sparkles, Calendar, MapPin } from 'lucide-react';

export const PastEvents = () => (
  <section className="py-16 md:py-24">
    <div className="container mx-auto">
      <div className="max-w-2xl">
        <div className="font-script text-2xl text-leaf">where we've been</div>
        <h2 className="font-display text-4xl sm:text-5xl text-primary font-medium leading-tight mt-1">
          Recent shows<br/><span className="italic font-light text-leaf">and stages.</span>
        </h2>
        <p className="mt-4 text-muted-foreground text-base md:text-lg">
          A taste of where the VDBF team has been pouring coffee, plating
          Danishes and talking shop with operators.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-12">
        <motion.a
          href="https://www.restaurantscanada.org/event/rc-show/"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="group relative flex flex-col rounded-3xl bg-card border border-border/70 overflow-hidden shadow-soft hover:shadow-pop hover:-translate-y-1 transition-all duration-500"
        >
          <div className="relative h-56 sm:h-64 bg-secondary/60 grid place-items-center p-10 overflow-hidden">
            <div className="absolute inset-0 bg-grain opacity-40 pointer-events-none" />
            <img
              src="https://www.restaurantscanada.org/wp-content/uploads/2024/04/RC-Show-1540x1120-1.png"
              alt="RC Show 2026 — Restaurants Canada"
              className="relative max-h-44 max-w-[75%] object-contain group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background/85 backdrop-blur text-[10px] uppercase tracking-[0.18em] text-primary font-medium">
              <Sparkles className="h-3 w-3 text-leaf" /> Past show · 2026
            </div>
            <div className="absolute top-4 right-4 h-9 w-9 rounded-full bg-background/85 backdrop-blur grid place-items-center text-primary group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
              <ArrowUpRight className="h-4 w-4" />
            </div>
          </div>
          <div className="p-7 flex flex-col flex-1">
            <h3 className="font-display text-2xl font-semibold text-primary">RC Show 2026</h3>
            <div className="text-xs uppercase tracking-[0.16em] text-leaf font-medium mt-1.5">
              Hosted by Restaurants Canada
            </div>
            <div className="mt-4 grid sm:grid-cols-2 gap-3">
              <div className="flex items-start gap-2.5">
                <Calendar className="h-4 w-4 text-leaf shrink-0 mt-0.5" />
                <div>
                  <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground">Dates</div>
                  <div className="text-sm font-medium text-primary mt-0.5">April 13 – 15, 2026</div>
                </div>
              </div>
              <div className="flex items-start gap-2.5">
                <MapPin className="h-4 w-4 text-leaf shrink-0 mt-0.5" />
                <div>
                  <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground">Venue</div>
                  <div className="text-sm font-medium text-primary mt-0.5">The International Centre, Mississauga</div>
                </div>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed mt-5">
              Canada's leading foodservice and hospitality event. Three days of solutions-oriented
              showcases, peer-to-peer networking, and flavor experiences with the country's top operators.
            </p>
            <div className="mt-auto pt-5 text-sm font-medium text-primary group-hover:text-leaf transition-colors inline-flex items-center gap-1.5">
              Visit restaurantscanada.org <ArrowUpRight className="h-4 w-4" />
            </div>
          </div>
        </motion.a>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.08 }}
          className="relative flex flex-col rounded-3xl bg-parchment/30 border border-dashed border-border p-10 items-center justify-center text-center min-h-[340px]"
        >
          <div className="h-14 w-14 rounded-2xl bg-secondary text-leaf grid place-items-center">
            <Sparkles className="h-6 w-6" />
          </div>
          <h3 className="font-display text-2xl font-semibold text-primary mt-5">More events on the way</h3>
          <p className="text-sm text-muted-foreground leading-relaxed mt-3 max-w-xs">
            We pack the proofer and hit the road. Conference recaps, photos and tasting notes
            will land here after each show.
          </p>
          <a href="mailto:toronto@vegandanishbakery.com?subject=Event collaboration" className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-leaf hover:underline underline-offset-4">
            Invite us to your show <ArrowUpRight className="h-4 w-4" />
          </a>
        </motion.div>
      </div>
    </div>
  </section>
);

export default PastEvents;
